// extracted by mini-css-extract-plugin
export default {"commentForm":"GeneralComment-module__commentForm--c12f4"};